/**
 * GrowthBook feature flag names, frontend and backend. Keep every flag key
 * here so there is a single place to see what flags exist in the app.
 */
export const FEATURE_FLAGS = {
  /** Object flag: { text, level } shown as the admin banner. */
  ADMIN_BANNER: 'admin-banner-calsg',
  /** Object flag: { text, level } shown as the public banner. */
  PUBLIC_BANNER: 'public-banner-calsg',
  /**
   * Boolean flag gating the "The CalSG platform" tab in the report issue
   * modal. Off (the GrowthBook default when the flag is missing) renders
   * just the report form, without a tab strip.
   */
  REPORT_ISSUE_PLATFORM_TAB: 'report-issue-platform-tab-calsg',
  /** Boolean flag gating the CSAT widget on the booking confirmation page. */
  RESPONDENT_CSAT: 'respondent-csat-calsg',
  /** Boolean flag gating the CSAT modal in the admin event builder. */
  ADMIN_CSAT: 'admin-csat-calsg',
  /**
   * Boolean flag showing the "Log in with one.gov.sg" button. Off when the
   * flag is missing; the backend also needs its ONEGOV_* credentials.
   */
  ONEGOV_LOGIN: 'onegov-login',
  /**
   * Boolean flag gating all MCP server access to the backend API, checked
   * server-side in McpAuthMiddleware. Off or missing rejects MCP calls
   * before any token processing (fails closed).
   */
  MCP: 'mcp-calsg',
} as const
